
define('jst!presence/presence_bar/_typing_info',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="typers-text"><%- typers %> <%= suffix %></div><div class="typing-animation">...</div>\n');
 });

